<template>
  <div>
    <el-drawer
      title="发票报销详情"
      custom-class="add-drawer"
      :visible.sync="drawer"
      :direction="$utils.isMobile() ? 'btt' : 'rtl'"
      :before-close="handleClose"
      :size="$utils.isMobile() ? '90%' : '35rem'"
      :wrapperClosable="false"
      :destroy-on-close="true"
    >
      <div class="detail-content" v-loading="loading">
        <!-- 基本信息 -->
        <div class="info-section">
          <div class="section-title">基本信息</div>
          <div class="detail-item">
            <span class="label">报销人</span>
            <span class="value">{{ detail.userName }}</span>
          </div>
          <div class="detail-item">
            <span class="label">报销类型</span>
            <span class="value">{{ getInvoiceTypeName(detail.invoiceType) }}</span>
          </div>
          <div class="detail-item">
            <span class="label">发生日期</span>
            <span class="value">{{ detail.invoiceDate }}</span>
          </div>
          <div class="detail-item">
            <span class="label">金额</span>
            <span class="value price">￥{{ detail.amount }}</span>
          </div>
          <div class="detail-item">
            <span class="label">关联拜访</span>
            <div class="value visit-detail-tags" v-if="detail.visitList && detail.visitList.length">
              <span v-for="item in detail.visitList" :key="item.id" class="detail-visit-tag">
                <i class="el-icon-location-outline"></i>
                <span>{{ item.visitDay }} {{ item.sname }}</span>
              </span>
            </div>
            <span class="value" v-else style="color:#c0c4cc">无</span>
          </div>
          <div class="detail-item" v-if="detail.remark">
            <span class="label">备注</span>
            <span class="value remark-text">{{ detail.remark }}</span>
          </div>
        </div>

        <!-- 发票附件 -->
        <div class="info-section">
          <div class="section-title">发票附件</div>
          <ul class="file-list" v-if="detail.fileList && detail.fileList.length">
            <li v-for="item in detail.fileList" :key="item.id">
              <i class="el-icon-document"></i>
              <span class="name">{{ item.fileName }}</span>
              <div class="file-actions">
                <el-button type="text" size="small" @click="filePreview(item)">查看</el-button>
                <el-button type="text" size="small" @click="fileDownload(item)">下载</el-button>
              </div>
            </li>
          </ul>
          <div v-else class="empty-text">暂无附件</div>
        </div>
      </div>

      <!-- 图片预览弹窗 -->
      <el-dialog :visible.sync="previewVisible" :title="previewTitle" :append-to-body="true" custom-class="preview-dialog" @close="closePreview">
        <img v-if="previewUrl" :src="previewUrl" alt="预览" class="preview-img" />
      </el-dialog>
      <drawer-close
        v-if="!$utils.isMobile()"
        :visible="drawer"
        right="35rem"
        @close="handleClose"
      ></drawer-close>
    </el-drawer>
  </div>
</template>
<script>
import { findOneInvoiceById, downInvoiceFile } from "@/api/invoice/index.js";
export default {
  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
    itemId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      detail: {},
      previewVisible: false,
      previewUrl: "",
      previewTitle: "",
    };
  },
  watch: {
    drawer(val) {
      if (val && this.itemId) {
        this.findDetail();
      }
    },
  },
  methods: {
    // 报销类型名称
    getInvoiceTypeName(type) {
      let map = { 1: "住宿费", 2: "交通费", 4: "客户维护费", 6: "服务费", 5: "其他"};
      return map[type] || "--";
    },
    findDetail() {
      this.loading = true;
      findOneInvoiceById({ id: this.itemId })
        .then((res) => {
          this.detail = res.data || {};
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err.status === 888) return;
          this.$MessageBox.MessageWarning(err.data.msg);
        });
    },
    // 下载附件
    fileDownload({ id }) {
      downInvoiceFile({ fileId: id })
        .then((res) => {
          if (res.data.type === "application/json") {
            let blobReader = new Response(res.data).json();
            blobReader.then((item) => {
              this.$MessageBox.MessageWarning(item.msg);
            });
          } else {
            this.$utils.download(res);
          }
        })
        .catch((err) => {
          this.$MessageBox.MessageWarning(err.data.msg);
        });
    },
    // 查看附件（图片预览 / PDF新窗口打开）
    filePreview(item) {
      let imageTypes = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
      let isImage = imageTypes.indexOf((item.fileType || "").toLowerCase()) !== -1;
      downInvoiceFile({ fileId: item.id })
        .then((res) => {
          if (res.data.type === "application/json") {
            let blobReader = new Response(res.data).json();
            blobReader.then((data) => {
              this.$MessageBox.MessageWarning(data.msg);
            });
            return;
          }
          let blob = new Blob([res.data], { type: res.data.type });
          let url = window.URL.createObjectURL(blob);
          if (isImage) {
            this.previewUrl = url;
            this.previewTitle = item.fileName;
            this.previewVisible = true;
          } else {
            // 非图片文件（如PDF）在新窗口打开
            window.open(url, "_blank");
            window.URL.revokeObjectURL(url);
          }
        })
        .catch((err) => {
          this.$MessageBox.MessageWarning(err.data.msg);
        });
    },
    // 关闭预览
    closePreview() {
      if (this.previewUrl) {
        window.URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = "";
      }
    },
    handleClose() {
      this.closePreview();
      this.previewVisible = false;
      this.detail = {};
      this.$emit("update:drawer", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-content {
  padding-bottom: 2rem;
}
.info-section {
  margin-bottom: 1.5rem;
  .section-title {
    font-size: 1.05rem;
    font-weight: 600;
    color: $primary-font-color;
    padding-left: 0.6rem;
    border-left: 3px solid $primary-btn-color;
    margin-bottom: 1rem;
  }
}
.detail-item {
  display: flex;
  padding: 0.4rem 0;
  line-height: 1.6;
  .label {
    width: 5rem;
    flex-shrink: 0;
    color: #999;
  }
  .value {
    flex: 1;
    color: $primary-font-color;
    word-break: break-all;
  }
  .price {
    color: $error-font-color;
    font-weight: 600;
  }
  .remark-text {
    white-space: pre-wrap;
  }
}
.visit-detail-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.detail-visit-tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0.18rem 0.55rem;
  background: #f0f7ff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  font-size: 0.78rem;
  color: #409eff;
  line-height: 1.4;
  i {
    font-size: 0.78rem;
  }
}
.file-list {
  width: 100%;
  list-style: none;
  li {
    display: flex;
    align-items: center;
    width: 100%;
    color: #606266;
    margin-top: 5px;
    padding: 0.4rem 0.6rem;
    line-height: 1.6;
    border-radius: 6px;
    cursor: pointer;
    border: 1px solid #ebeef5;
    .name {
      max-width: 400px;
      margin-left: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .file-actions {
      margin-left: auto;
      flex-shrink: 0;
      .el-button {
        padding: 0 5px;
      }
    }
    &:hover {
      color: $primary-btn-color;
      background-color: #f5f7fa;
    }
  }
}
.empty-text {
  color: #999;
  font-size: 0.9rem;
  padding: 0.5rem 0;
}
</style>
<style lang="scss">
.preview-dialog {
  margin-top: 10vh !important;
  .el-dialog__header {
    padding: 15px 20px 10px;
    margin-right: 0;
  }
  .el-dialog__headerbtn {
    top: 15px;
  }
  .el-dialog__body {
    text-align: center;
    padding: 0 10px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .preview-img {
    max-width: 100%;
    max-height: calc(100vh - 20vh - 80px);
    object-fit: contain;
    display: block;
  }
}
</style>
